import { Dispatch } from 'redux';
import { config } from 'config/config';
import * as ActionTypes from 'store/actionTypes';
import apiClient from 'utils/apiClient';

export type DictScope = 'public' | 'full';

const PUBLIC_STORAGE_KEY = 'translations_public';
const FULL_STORAGE_KEY = 'translations_full';

const storageKeyFor = (scope: DictScope) =>
    scope === 'full' ? FULL_STORAGE_KEY : PUBLIC_STORAGE_KEY;

const urlFor = (scope: DictScope) =>
    scope === 'full'
        ? config.api.routes.backend.languageDictionary
        : config.api.routes.backend.publicLanguageDictionary;

export const loadLanguageDictionary = (scope: DictScope = 'public') => async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.LANGUAGE_DICTIONARY_GET_IN_PROGRESS });

    const storageKey = storageKeyFor(scope);

    try {
        let translations;

        const cached = sessionStorage.getItem(storageKey);
        if (cached) {
            translations = JSON.parse(cached);
        } else {
            const params = scope === 'public' ? { host: window.location.hostname } : undefined;
            const response = await apiClient.request(urlFor(scope), params, 'GET');
            sessionStorage.setItem(storageKey, JSON.stringify(response.translations));
            translations = response.translations;
        }

        dispatch({
            type: ActionTypes.LANGUAGE_DICTIONARY_GET_SUCCESS,
            payload: translations,
        });
    } catch (error) {
        dispatch({ type: ActionTypes.LANGUAGE_DICTIONARY_GET_FAILED });
    }
};

export const clearLanguageDictionaryCache = () => {
    sessionStorage.removeItem(PUBLIC_STORAGE_KEY);
    sessionStorage.removeItem(FULL_STORAGE_KEY);
};

export const readCachedLanguageDictionary = (): Record<string, any> | null => {
    const raw =
        sessionStorage.getItem(FULL_STORAGE_KEY) ?? sessionStorage.getItem(PUBLIC_STORAGE_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};
